import { toEnglish } from '@/mixins/toEnglish'

export const gregorianToPersian = {
  mixins: [toEnglish],
  methods: {
    gregorianToPersian(dateString) {
      const date = new Date(dateString)

      // Convert the date to the Jalali calendar format using toLocaleDateString
      const jalaliDate = date.toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })

      // Reformat the Jalali date to 'YYYY-MM-DD'
      const [year, month, day] = jalaliDate.split('/')

      const formattedJalaliDate = `${this.toEnglish(year)}-${this.toEnglish(
        month
      )}-${this.toEnglish(day)}`

      return formattedJalaliDate
    },
  },
}
